import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const Img = styled('img')(mapStylesProp);
